export default async function loadDictionary(locale: string) {
  const t = await import(`../../../../packages/shared/src/i18n/translations/${locale}.json`)
  return t.default
}
